<app-modal
	class="subscription-config-stepper"
	*ngIf="vo$ | async; let vo"
	(triggerClose)="close()">
	<div
		class="subscription-config-stepper__content"
		modal-body>
		<mat-stepper
			[linear]="true"
			[selectedIndex]="vo.currentStep"
			(selectionChange)="changeCurrentStep($event)"
			(animationDone)="onStepReady()">

			<!-- Datablock Selection Step -->
			<mat-step
				#step1
				[completed]="vo.currentStep > SubscriptionConfigurationStep.Datablock ||
					(vo.currentStep === SubscriptionConfigurationStep.Datablock && vo.stepValidity)"
				[editable]="vo.isDatablockSelectionEnabled">
				<ng-template matStepperIcon="edit">
					<mat-icon
						*ngIf="step1.completed">
						done</mat-icon>
				</ng-template>

				<ng-template matStepLabel>
					<span
						i18n="@@subscription.config.stepper.datablock">
						datablock
					</span>
				</ng-template>

				<div class="subscription-config-stepper__datablock">
					<dc-alert
						class="info"
						type="info"
						message="datablock"
						i18n-message="@@subscription.config.stepper.datablock.description">
					</dc-alert>

					<app-panel
						headerHeight="3rem"
						isAlwaysOpen="true"
						hasSearchableGrid="true"
						hasRefresh="true"
						[itemsCount]="vo.datablockList.elements.size"
						(refresh)="refreshDatablocks()"
						(search)="search($event)">
							<span
								panel-title
								i18n="@@subscription.config.stepper.datablock.list.title">
								datablocks
							</span>
						<ng-container *ngTemplateOutlet="datablocks"></ng-container>
					</app-panel>
				</div>

			</mat-step>

			<!-- Metadata Step -->
			<mat-step
				[completed]="
				vo.currentStep > SubscriptionConfigurationStep.Metadata ||
				(vo.currentStep === SubscriptionConfigurationStep.Metadata && vo.stepValidity)">

				<ng-template matStepLabel>
					<span
						i18n="@@subscription.config.stepper.metadata">
						metadata
					</span>
				</ng-template>

				<ng-template matStepContent>
					<div class="subscription-config-stepper__metadata">
						<dc-alert
							class="info"
							type="info"
							message="metadata"
							i18n-message="@@subscription.config.stepper.metadata.description">
						</dc-alert>

						<div class="metadata-config">
							<app-card-outline>
								<div card-outline-title>
								<span
									i18n="@@subscription.config.stepper.internalMetadata.title">
									internal-metadata
								</span>
								</div>
								<app-internal-metadata-config
									card-outline-content
									[internalMetadata]="vo.internalMetadata"
									[isInViewMode]="false"></app-internal-metadata-config>
							</app-card-outline>

							<app-card-outline>
								<div card-outline-title>
								<span
									i18n="@@subscription.config.stepper.publicMetadata.title">
									public-metadata</span>
								</div>
								<app-public-metadata-config
									card-outline-content
									[publicMetadata]="vo.publicMetadata"
									[isInViewMode]="false"></app-public-metadata-config>
							</app-card-outline>
						</div>
					</div>
				</ng-template>
			</mat-step>

			<!-- Columns Selection Step -->
			<mat-step
				[completed]="
				vo.currentStep > SubscriptionConfigurationStep.ColumnsSelection ||
				(vo.currentStep === SubscriptionConfigurationStep.ColumnsSelection && vo.stepValidity)">

				<ng-template matStepLabel>
					<span
						i18n="@@subscription.config.stepper.columnsSelection">
						columns
					</span>
				</ng-template>

				<ng-template matStepContent>
					<div class="subscription-config-stepper__columns">
						<dc-alert
							class="info"
							type="info"
							message="columns"
							i18n-message="@@subscription.config.stepper.columnsSelection.description">
						</dc-alert>

						<app-panel
							headerHeight="3rem"
							isAlwaysOpen="true"
							hasSearchableGrid="true"
							hasRefresh="true"
							[itemsCount]="vo.datablockColumns.size"
							(refresh)="refreshColumns()"
							(search)="columnsSelection.search($event)">
							<span
								panel-title
								i18n="@@subscription.columns.config.list.title">
								columns
							</span>
							<div
								panel-info
								class="subscription-column-step-panel-info">
								<ng-container
									*ngIf="
										vo.error !== undefined &&
										vo.error.key === SubscriptionErrorKey.NoSelectColumns">
									<div class="columns-alert error">
										<mat-icon color="warn" [svgIcon]="DcIcons.Warning"></mat-icon>
										<span
											i18n="@@subscription.columns.config.alert.minOneActive">
											min one active column
										</span>
									</div>
								</ng-container>
							</div>

							<app-columns-config
								id="columns-datablock"
								#columnsSelection="ColumnsGrid"
								[columns]="vo.datablockColumns"
								[isInViewMode]="false"
								[columnsConfigMode]="'SELECTION'"></app-columns-config>
						</app-panel>
					</div>
				</ng-template>
			</mat-step>

			<!-- Configuration Columns Step -->
			<mat-step
				[completed]="
				vo.currentStep > SubscriptionConfigurationStep.ColumnsProperties ||
				(vo.currentStep === SubscriptionConfigurationStep.ColumnsProperties && vo.stepValidity)">

				<ng-template matStepLabel>
					<span
						i18n="@@subscription.config.stepper.columnsProperties">
						columns-properties
					</span>
				</ng-template>

				<ng-template matStepContent>
					<div class="subscription-config-stepper__columns">
						<dc-alert
							class="info"
							type="info"
							message="columns"
							i18n-message="@@subscription.config.stepper.columnsProperties.description">
						</dc-alert>

						<app-panel
							headerHeight="3rem"
							isAlwaysOpen="true"
							hasSearchableGrid="true"
							hasRefresh="true"
							[itemsCount]="vo.datablockColumns.size"
							[actions]="vo.columnsPanelActions"
							(refresh)="refreshColumns()"
							(search)="columnsProperties.search($event)">
							<span
								panel-title
								i18n="@@subscription.columns.config.list.title">
								columns
							</span>
							<div
								panel-info
								class="subscription-column-step-panel-info">
								<ng-container
									*ngIf="
											vo.error !== undefined &&
											vo.error.key === SubscriptionErrorKey.InvalidSubscriptionColumns">
									<div class="columns-alert error">
										<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
										<span
											i18n="@@subscription.columns.config.alert.invalidColumns">
											invalid columns
										</span>
									</div>
								</ng-container>
							</div>

							<app-columns-config
								id="columns-properties"
								#columnsProperties="ColumnsGrid"
								[columns]="vo.subscriptionColumns"
								[isInViewMode]="false"
								[columnsConfigMode]="'PARAMETER'"></app-columns-config>
						</app-panel>
					</div>
				</ng-template>
			</mat-step>

			<!-- Profile Creation Step -->
			<mat-step
				[completed]="
				vo.currentStep > SubscriptionConfigurationStep.Profile ||
				(vo.currentStep === SubscriptionConfigurationStep.Profile && vo.stepValidity)">

				<ng-template matStepLabel>
					<span
						i18n="@@subscription.config.stepper.profile">
						profile</span>
				</ng-template>

				<ng-template matStepContent>
					<div class="subscription-config-stepper__profile">
						<dc-alert
							class="info"
							type="info"
							message="columns"
							i18n-message="@@subscription.config.stepper.profile.description">
						</dc-alert>

						<app-profile-config
							[mode]="'STEPPER'"
							[profileConfig]="profileConfig"
							[availableColumns]="vo.subscriptionColumns"></app-profile-config>
					</div>
				</ng-template>
			</mat-step>
		</mat-stepper>
	</div>

	<div
		class="subscription-config-stepper__footer"
		modal-footer>
		<div
			*ngIf="vo.error"
			class="error-alert error">
			<mat-icon
				[ngClass]="{ 'warning': vo.error.type === 'warning' }"
				color="warn"
				[svgIcon]="vo.error.type === 'critic'? DcIcons.Error: DcIcons.Warning"></mat-icon>
			<span>{{vo.error.message}}</span>
		</div>

		<button
			*ngIf="
			vo.currentStep !== SubscriptionConfigurationStep.Datablock &&
					 vo.currentStep !== SubscriptionConfigurationStep.Metadata"
			id="{{ cmpId }}-back-btn"
			mat-stroked-button
			color="accent"
			(click)="backStep()">
			<span i18n="@@general.stepper.back">back</span>
		</button>

		<button
				*ngIf="vo.currentStep === SubscriptionConfigurationStep.Metadata &&
						vo.isDatablockSelectionEnabled"
				id="{{ cmpId }}-back-btn"
				mat-stroked-button
				color="accent"
				(click)="backStep()">
				<span i18n="@@general.stepper.back">back</span>
		</button>

		<button
			*ngIf="vo.currentStep !== SubscriptionConfigurationStep.Profile"
			id="{{ cmpId }}-next-btn"
			[disabled]="!vo.stepValidity"
			[color]="'primary'"
			mat-raised-button
			(click)="nextStep()">
			<span i18n="@@general.stepper.next">next</span>
		</button>

		<button
			*ngIf="vo.currentStep === SubscriptionConfigurationStep.Profile"
			id="{{ cmpId }}-save-btn"
			[disabled]="!vo.stepValidity"
			[color]="'primary'"
			mat-raised-button
			(click)="saveNewSubscription()">
			<span i18n="@@general.action.save">save</span>
		</button>

	</div>

	<ng-template #datablocks>
		<dx-data-grid
			keyExpr="id"
			[elementAttr]="{
			id: 'subscription-datablock-list',
			class: 'subscription-datablock-list'
		}"
			[dataSource]="vo.datablockList.elements | toArray"
			[hoverStateEnabled]="true"
			[showColumnHeaders]="true"
			[allowColumnResizing]="true"
			[columnAutoWidth]="false"
			[showRowLines]="false"
			[showColumnLines]="false"
			[rowAlternationEnabled]="false"
			[showBorders]="false"
			[width]="'100%'"
			(onSelectionChanged)="selectDatablock($event)">
			<dxo-selection mode="single"></dxo-selection>
			<dxo-load-panel
				shadingColor="rgba(0,0,0,0)"
				[indicatorSrc]="DcLoaders.LoaderInfinite"
				[height]="100"
				[width]="100"
				[enabled]="true"
				[showIndicator]="true"
				[showPane]="true"
				[shading]="true"></dxo-load-panel>

			<!-- Fixable in position columns	-->
			<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

			<dxo-scrolling mode="standard"></dxo-scrolling>

			<ng-container *ngFor="let col of vo.datablockList.availableColumns | toArray">
				<dxi-column
					*ngIf="col.field === 'label'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="true"
					[dataType]="col.type"
					[alignment]="'left'"
					[width]="'80%'"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="datablockLabelTemplate"></dxi-column>
				<dxi-column
					*ngIf="col.field === 'columnsCount'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable ?? false"
					[allowSorting]="true"
					[dataType]="col.type"
					[alignment]="'left'"
					[width]="'7%'"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="columnsTemplate"></dxi-column>
				<dxi-column
					*ngIf="col.field === 'updatedByAvatar'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[width]="'5%'"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="avatarTemplate"></dxi-column>
				<dxi-column
					*ngIf="col.field === 'updateDate'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowHeaderFiltering]="col.hasHeaderFilter"
					[allowSorting]="true"
					[dataType]="col.type"
					[format]="col.format"
					[width]="'10%'"
					[alignment]="'left'"
					[visibleIndex]="col.visibleIndex"
					cellTemplate="timestampTemplate">
				</dxi-column>
			</ng-container>

			<div
				*dxTemplate="let cell of 'datablockLabelTemplate'"
				class="datablock-column-template">
				<span class="datablock-column-template__label">
					{{ cell.data['label'] }}
					<a appNavigate [navigateTo]="cell.data['url']">
						<mat-icon
							[svgIcon]="DcIcons.OpenInNewTab"
							matTooltip="open db in new tab"
							i18n-matTooltip="@@subscription.list.sourceTooltip"
							matTooltipPosition="after"></mat-icon>
					</a>
				</span>
			</div>

			<div class="columns-count" *dxTemplate="let cell of 'columnsTemplate'">
				<app-overlay-badge
					[icon]="ComponentIcons.Column"
					[value]="cell.data['columnsCount']"
					[active]="true"
					[isOpen]="vo.openedOverlayDatablock.datablockId === cell.data['id']"
					(overlayDismiss)="closeColumnsPopover()"
					(click)="openColumnsPopover($event, cell.data['id'])">
					<app-popover
						overlayContent
						label="columns"
						i18n-label="@@subscription.config.datablock.list.column.columns"
						[icon]="{ iconName: ComponentIcons.Column }"
						[count]="cell.data['columns'].length"
						(adbPopoverClose)="closeColumnsPopover()">
						<ng-container>
							<div
								*ngFor="let column of cell.data['columns']"
								class="datablock-columns__body-row">
								<app-column-type
									[type]="column['type']"
									[isList]="column['isList']"></app-column-type>
								<span>{{ column.label }}</span>
							</div>
						</ng-container>
					</app-popover>

				</app-overlay-badge>
			</div>

			<div *dxTemplate="let cell of 'avatarTemplate'">
				<app-avatar
					[avatar]="cell.data['updatedByAvatar']"
					[withTooltip]="true"></app-avatar>
			</div>

			<div *dxTemplate="let cell of 'timestampTemplate'">
				<span>{{ cell.data['updateDate'] | dayjsDate: 'DateTime' }}</span>
			</div>

			<!-- Sorting	-->
			<dxo-sorting mode="multiple"></dxo-sorting>

			<!-- Pagination -->
			<dxo-paging [pageSize]="1000"></dxo-paging>

			<dxo-pager [visible]="false"></dxo-pager>

			<!-- Filterable columns	-->
			<dxo-header-filter [visible]="false"></dxo-header-filter>

			<dxo-filter-row [visible]="false"></dxo-filter-row>

		</dx-data-grid>
	</ng-template>
</app-modal>
